import { useEffect } from "react";

export function useAppViewport() {
  useEffect(() => {
    const vv = window.visualViewport;
    const root = document.documentElement;
    const update = () => {
      const h = vv ? vv.height : window.innerHeight;
      root.style.setProperty("--app-h", `${h}px`);
      root.style.setProperty("--app-top", `${vv ? vv.offsetTop : 0}px`);
      root.dataset.kb = vv && window.innerHeight - vv.height > 140 ? "true" : "false";
    };
    update();
    vv?.addEventListener("resize", update);
    vv?.addEventListener("scroll", update);
    window.addEventListener("resize", update);
    return () => {
      vv?.removeEventListener("resize", update);
      vv?.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);
}
